// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3dV12","unreadBadge":"styles_unreadBadge___YYK5","modalContent":"styles_modalContent__1hJ-J","modal":"styles_modal__22gHi"};